/*=============================================== DemoPagination ===============================================*/

import {
    Pagination,
    Card,
    Text,
    Grid,
    uuid,
    generateNumbers,
    usePaginatedData,
} from "tsx-library-julseb"

import { WrapperPagination } from "components"

const DemoPaginationQuery = () => {
    const arr: string[] = generateNumbers(1, 201).map(n => `Hello ${n}`)
    const { getNumberOfPages, getPaginatedData } = usePaginatedData(arr)
    const searchParams: string[][] = [
        ["search", "hello"],
        ["order", "asc"],
    ]

    return (
        <WrapperPagination title="Demo Pagination query">
            {getPaginatedData() && (
                <Grid col={4} gap="s">
                    {getPaginatedData().map(text => (
                        <Card border={{ width: 1 }} key={uuid()}>
                            <Text>{text}</Text>
                        </Card>
                    ))}
                </Grid>
            )}

            {getNumberOfPages() > 1 && (
                <Pagination
                    totalPages={getNumberOfPages()}
                    queries={searchParams}
                />
            )}
        </WrapperPagination>
    )
}

export default DemoPaginationQuery
